module.exports = "<p>\n  people works!\n</p>\n"